<div>
  <img src="assets/images/vertical-vbill-ads.jpg" alt=""  width="76%" height="auto">
</div>